

export class SmsAllocationOutputWithoutStatus implements ISmsAllocationOutputWithoutStatus {
    /** The auto-generated id of the sms allocation master */
    sms_allocation_id!: number;
    /** The sms allocation name with 255 character limit */
    sms_allocation_name!: string;
    /** The activation date with 10 character limit */
    activation_date!: string;
    /** The expiry date with 10 character limit */
    expiry_date!: string;
    /** The available sms with 500 character limit */
    available_sms!: string;
    /** Max sms allocation */
    max_sms!: number;
    /**  Monthly max sms allocation */
    monthly_max_sms!: number;
    /**  daily max sms allocation */
    daily_max_sms!: number;
    /** The company name */
    company_name!: string;

    constructor(data?: ISmsAllocationOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sms_allocation_id = _data["sms_allocation_id"];
            this.sms_allocation_name = _data["sms_allocation_name"];
            this.activation_date = _data["activation_date"];
            this.expiry_date = _data["expiry_date"];
            this.available_sms = _data["available_sms"];
            this.max_sms = _data["max_sms"];
            this.monthly_max_sms = _data["monthly_max_sms"];
            this.daily_max_sms = _data["daily_max_sms"];
            this.company_name = _data["company_name"];
        }
    }

    static fromJS(data: any): SmsAllocationOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SmsAllocationOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sms_allocation_id"] = this.sms_allocation_id;
        data["sms_allocation_name"] = this.sms_allocation_name;
        data["activation_date"] = this.activation_date;
        data["expiry_date"] = this.expiry_date;
        data["available_sms"] = this.available_sms;
        data["max_sms"] = this.max_sms;
        data["monthly_max_sms"] = this.monthly_max_sms;
        data["daily_max_sms"] = this.daily_max_sms;
        data["company_name"] = this.company_name;
        return data; 
    }
}

export interface ISmsAllocationOutputWithoutStatus {
    /** The auto-generated id of the sms allocation master */
    sms_allocation_id: number;
    /** The sms allocation name with 255 character limit */
    sms_allocation_name: string;
    /** The activation date with 10 character limit */
    activation_date: string;
    /** The expiry date with 10 character limit */
    expiry_date: string;
    /** The available sms with 500 character limit */
    available_sms: string;
    /** Max sms allocation */
    max_sms: number;
    /**  Monthly max sms allocation */
    monthly_max_sms: number;
    /**  daily max sms allocation */
    daily_max_sms: number;
    /** The company name */
    company_name: string;
}

